import { Component, Input } from '@angular/core';
import { SharedComponents } from '../../shared.module';

/**
 * A simple component to display a "No Data" message when there is no data available.
 * The message can be customized via an input property.
 */
@Component({
  selector: 'app-no-data',
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss'
})
export class NoDataComponent {

  @Input()
  customMessage!: string;
  
}
